import { useState } from 'react';
import { TextField, TextFieldProps } from '@mui/material';

type TVTextFieldProps = TextFieldProps & {
  id?: string;
  valor?: (id: string, valor: string) => void;
}
export const VFieldMoney4Faturamento: React.FC<TVTextFieldProps> = ({ valor, id, ...rest }) => {
  const formatValue = (inputValue: string | number): string => {
    let formattedValue: string;
    if (typeof inputValue === 'number') {
      inputValue = inputValue.toString();
    }
    if (!inputValue.includes('.')) {
      formattedValue = inputValue.replace(/\D/g, '');
      formattedValue += ',0000'; 
      formattedValue = formattedValue.replace(/(\d)(?=(\d{3})+(,))/g, '$1.'); 
    } else {
      formattedValue = inputValue.replace(/\./g, ','); 
      formattedValue = formattedValue.replace(/(\d+,\d{0,4})\d*/, '$1'); 
      formattedValue = formattedValue.replace(/(\d)(?=(\d{3})+(,))/g, '$1.'); 
    }
    return formattedValue;
  };
  const formatInputValue = (inputValue: string) => {
    inputValue = inputValue.replace(/\D/g, '');
    inputValue = inputValue.replace(/(\d)(\d{4})$/, '$1,$2');
    inputValue = inputValue.replace(/(?=(\d{3})+(\D))\B/g, '.');
    return inputValue;
  };
  const formatSimple = (inputValue: string): string => {
    inputValue = inputValue.replace(/\./g, '');
    inputValue = inputValue.replace(/,/g, '.');
    return inputValue;
  };
  const [value, setValue] = useState(formatValue(String(rest.defaultValue)));
  return (
    <TextField
      {...rest}
      value={value}
      onChange={e => { setValue(formatInputValue(e.target.value)); valor?.(id || '', formatSimple(formatInputValue(e.target.value))); rest.onChange?.(e); }}
      onKeyDown={(e) => { rest.onKeyDown?.(e); }}
    />
  );
}; 